import { atom } from 'jotai';

export interface CampaignBanner {
  /**
   * 活动 Banner 图，对齐端内官号尺寸，即 1125 * 600
   */
  bannerUrl: string;
  title: string;
  campaignId: string;
  buttonText: string;
  startTime?: number;
  endTime?: number;
}

export const $CampaignBanner = atom<CampaignBanner[]>([]);
$CampaignBanner.debugLabel = '$CampaignBanner';
